import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const MedQuantityPDF = ({
  med
}) => {
  const medQuantity = med.quantity;
  const quantityValue = Math.trunc(Number(medQuantity));
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width6
  }, med.quantity === '' && /*#__PURE__*/React.createElement(Text, {
    style: [styles.medsTableMainDetailsText]
  }, "0") || med.quantity && /*#__PURE__*/React.createElement(Text, {
    style: [styles.medsTableMainDetailsText]
  }, `${quantityValue}`));
};